import React, { useContext, useEffect } from 'react'
import PropTypes from 'prop-types'
import ReactMapGL, { Marker } from 'react-map-gl'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faMapMarkerAlt } from '@fortawesome/pro-solid-svg-icons'

import useSetState from 'hooks/useSetState'

import GlobalContext from 'agency/digital_renderer/utils/context'
import deviceStyle from 'agency/digital_renderer/utils/deviceStyle'

import 'mapbox-gl/dist/mapbox-gl.css'

const defaultState = {
  viewport: {
    width: '100%',
    height: '100%',
    latitude: -33.865143,
    longitude: 151.2099,
    zoom: 14,
  },
}

const MapboxMap = (props) => {
  const { options } = props
  const {
    mapCoordSource,
    mapLatitude: customLatitude,
    mapLongitude: customLongitude,
    mapStyle,
    mapMarkerImageUrl,
    mapMarkerLeftOffset,
    mapMarkerTopOffset,
    mapZoom,
  } = options || {}

  const style = deviceStyle(props)

  const [state, setState] = useSetState(defaultState)
  const { viewport } = state

  const defaultContext = useContext(GlobalContext)
  const {
    apiKeys: { mapboxPublicToken },
    campaign: { latitude, longitude },
  } = defaultContext

  const mapLatitude = mapCoordSource === 'campaign' ? Number(latitude) : Number(customLatitude)
  const mapLongitude = mapCoordSource === 'campaign' ? Number(longitude) : Number(customLongitude)

  useEffect(() => {
    const nextViewport = {
      ...viewport,
    }

    if (mapZoom) nextViewport.zoom = Number(mapZoom)
    if (mapLatitude) nextViewport.latitude = mapLatitude
    if (mapLongitude) nextViewport.longitude = mapLongitude
    if (style.height) nextViewport.height = style.height
    if (style.width) nextViewport.width = style.width

    setState({
      viewport: nextViewport,
    })
  }, [mapLatitude, mapLongitude, mapZoom])

  return (
    <ReactMapGL
      mapStyle={mapStyle || 'mapbox://styles/realhub/ck0rj3dag4fw11cli6j016e3i'}
      mapboxApiAccessToken={mapboxPublicToken}
      onViewportChange={v => setState({ viewport: v })}
      {...viewport}
    >
      <Marker
        latitude={mapLatitude || -33.865143}
        longitude={mapLongitude || 151.2099}
        offsetLeft={mapMarkerLeftOffset || 0}
        offsetTop={mapMarkerTopOffset || 0}
      >
        {mapMarkerImageUrl ? <img alt="Marker" src={mapMarkerImageUrl} /> : <FontAwesomeIcon icon={faMapMarkerAlt} />}
      </Marker>
    </ReactMapGL>
  )
}

MapboxMap.propTypes = {
  options: PropTypes.object,
}

export default MapboxMap
